import { render, staticRenderFns } from "./WidgetExample.vue?vue&type=template&id=3965ce3a&scoped=true&"
import script from "./WidgetExample.vue?vue&type=script&lang=js&"
export * from "./WidgetExample.vue?vue&type=script&lang=js&"
import style0 from "./WidgetExample.vue?vue&type=style&index=0&id=3965ce3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3965ce3a",
  null
  
)

export default component.exports